angular.module('app.core').factory('userProfileFactory', ['$http', function ($http) {
    var _apiName = 'SysUsuario';

    var _findUserLoggedRecord = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindUserLoggedRecord');
    };

    var _save = function (dto) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Update', dto);
    };

    var factory = {};

    factory.findUserLoggedRecord = _findUserLoggedRecord;
    factory.save = _save;

    return factory;
}]);
